export default {
    STORE: 'nykaa',
    PAGE_PREFIX: 'other',
};
export var variantTypes;
(function (variantTypes) {
    variantTypes["SIZE"] = "Size";
    variantTypes["SHADE"] = "Shade";
    variantTypes["SIMPLE"] = "Simple";
    variantTypes["BUNDLE"] = "Bundle";
})(variantTypes || (variantTypes = {}));
export const configureType = {
    SHADE: 'shade',
    WEIGHT_CONFIGURE: 'weight_configure',
    SIZE: 'size',
};
export const PRODUCT_WIDGET_DATA = 'ProductWidget';
export const PDP = 'pdp';
export const STORY_WIDGET_TYPE = {
    DYNAMIC_HTML: 'DYNAMIC_HTML',
    STATIC_HTML: 'STATIC_HTML',
};
export const webActionTypes = {
    URL_REDIRECTION: 'url_redirection',
    PHONE: 'phone',
};
